import {
  ability,
  ACTIONS,
  hasUpdatedAbilityAtom,
  PERMISSION_SUBJECTS,
} from '@/helpers/casl/ability';
import { useIsReviewingOtherUser } from '@/hooks/query/useQueryUser';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';

export const useShowSessionsListAssistantView = () => {
  const hasUpdatedAbility = useAtomValue(hasUpdatedAbilityAtom);
  const isReviewingOtherUser = useIsReviewingOtherUser();

  const showSessionsListAssistantView = useMemo(() => {
    return (
      hasUpdatedAbility &&
      ability.cannot(ACTIONS.ACCESS, PERMISSION_SUBJECTS.SESSION_CREATE) &&
      !isReviewingOtherUser
    );
  }, [hasUpdatedAbility, isReviewingOtherUser]);

  return showSessionsListAssistantView;
};
